import { ContextModalProps } from '@mantine/modals'
import PlaceConfigForm from 'components/place/PlaceConfigForm'
import { useUpdateRack } from 'hooks/places'
import { PlaceConfig } from 'types/places'

type Props = {
  initialValues: PlaceConfig
}

export default function UpdatePlaceConfigModal({
  context,
  id,
  innerProps: { initialValues },
}: ContextModalProps<Props>) {
  const updateRack = useUpdateRack()
  async function submit(values: PlaceConfig) {
    await updateRack.mutateAsync(values)
  }

  return <PlaceConfigForm onSubmit={submit} onCancel={() => context.closeModal(id)} initialValues={initialValues} />
}
